import React from 'react';

import { FormField, Label } from '@zillow/constellation';

import SwitchWithTitle from '../../../Widgets/SwitchWithTitle';

type Props = {
  header: string;
  subheader: string;
  switchOn: boolean;
  onSwitchToggle: () => void;
};

export default function HeaderToggle({ header, subheader, switchOn, onSwitchToggle }: Props): JSX.Element {
  return (
    <FormField
      label={
        <Label size="lg" data-test="header">
          {header}
        </Label>
      }
      control={<SwitchWithTitle text={subheader} onClick={onSwitchToggle} toggled={switchOn} />}
    />
  );
}
